export function getPersistenceType() {
  if (!window.posthog) {
    console.error('Posthog instance not found');

    return;
  }

  if (!window.posthog.config) {
    console.error("Posthog config persistence attribute not found");

    return;
  }

  return window.posthog.config.persistence;
}

export function getProperties() {
  if (!window.posthog) {
    console.error('Posthog instance not found');

    return null;
  }

  try {
    return window.posthog.capture('$pageview').properties
  } catch (e) {
    console.error(e);
    return null;
  }
}

export function isUsingCookie() {
  return getPersistenceType() == 'cookie';
}
export default {
  getProperties,
  getPersistenceType,
  isUsingCookie
};
